import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms"
import { LoginRequest } from "../login/login-request"

export class ResetPasswordConfirmForm extends UntypedFormGroup {
  constructor() {
    super({
      password: new UntypedFormControl("", [Validators.required]),
      confirmPassword: new UntypedFormControl("", [Validators.required]),
      unauthorized: new UntypedFormControl(false, [])
    })
  }

  public buildUser(): LoginRequest {
    return {
      username: this.value.username as string,
      password: this.value.password as string
    }
  }
}
